import { axios } from '@/utils/request'
const api = "/Config"
export default {
  OpinList: (parameter) => {
    return axios({
      url: `${api}/OpinList`,
      method: 'post',
      data: parameter
    })
  },
  Huida: (parameter) => {
    return axios({
      url: `${api}/Huida`,
      method: 'post',
      data: parameter
    })
  },
  AdminList: (parameter) => {
    return axios({
      url: `${api}/AdminList`,
      method: 'post',
      data: parameter
    })
  },
  AddAdmin: (parameter) => {
    return axios({
      url: `${api}/AddAdmin`,
      method: 'post',
      data: parameter
    })
  },
  DeleteAdmin: (parameter) => {
    return axios({
      url: `${api}/DeleteAdmin`,
      method: 'post',
      data: parameter
    })
  },
  save_admin: (parameter) => {
    return axios({
      url: `${api}/save_admin`,
      method: 'post',
      data: parameter
    })
  },
  config_list: (parameter) => {
    return axios({
      url: `${api}/config_list`,
      method: 'post',
      data: parameter
    })
  },
  find_config: (parameter) => {
    return axios({
      url: `${api}/find_config`,
      method: 'post',
      data: parameter
    })
  },
  save_config: (parameter) => {
    return axios({
      url: `${api}/save_config`,
      method: 'post',
      data: parameter
    })
  },
  query_photo: (parameter) => {
    return axios({
      url: `${api}/query_photo`,
      method: 'post',
      data: parameter
    })
  },
  add_photo: (parameter) => {
    return axios({
      url: `${api}/add_photo`,
      method: 'post',
      data: parameter
    })
  },
  save_photo: (parameter) => {
    return axios({
      url: `${api}/save_photo`,
      method: 'post',
      data: parameter
    })
  },
  delete_photo: (parameter) => {
    return axios({
      url: `${api}/delete_photo`,
      method: 'post',
      data: parameter
    })
  },
  FindPhoto: (parameter) => {
    return axios({
      url: `${api}/FindPhoto`,
      method: 'post',
      data: parameter
    })
  },

    query_rentplatform: (parameter) => {
        return axios({
            url: `${api}/query_rentplatform`,
            method: 'post',
            data: parameter
        })
    },
    add_rentplatform: (parameter) => {
        return axios({
            url: `${api}/add_rentplatform`,
            method: 'post',
            data: parameter
        })
    },
    save_rentplatform: (parameter) => {
        return axios({
            url: `Rentplatform/save_rentplatform`,
            method: 'post',
            data: parameter
        })
    },
    delete_rentplatform: (parameter) => {
        return axios({
            url: `${api}/delete_rentplatform`,
            method: 'post',
            data: parameter
        })
    },
    FindRentplatform: (parameter) => {
        return axios({
            url: `${api}/FindRentplatform`,
            method: 'post',
            data: parameter
        })
    },

    query_rentplatform: (parameter) => {
      return axios({
          url: `${api}/query_rentplatform`,
          method: 'post',
          data: parameter
      })
  },
  add_rentplatform: (parameter) => {
      return axios({
          url: `${api}/add_rentplatform`,
          method: 'post',
          data: parameter
      })
  },
  save_rentplatform: (parameter) => {
      return axios({
          url: `${api}/save_rentplatform`,
          method: 'post',
          data: parameter
      })
  },
  delete_rentplatform: (parameter) => {
      return axios({
          url: `${api}/delete_rentplatform`,
          method: 'post',
          data: parameter
      })
  },
  FindRentplatform: (parameter) => {
    return axios({
        url: `${api}/FindRentplatform`,
        method: 'post',
        data: parameter
    })
},

  vitalNumber: (parameter) => {
    return axios({
      url: `/index/vitalNumber`,
      method: 'post',
      data: parameter
    })
  },

  agentNumber: (parameter) => {
    return axios({
      url: `/index/agentNumber`,
      method: 'post',
      data: parameter
    })
  },
    agentAccessNumber: (parameter) => {
        return axios({
            url: `/index/agentAccessNumber`,
            method: 'post',
            data: parameter
        })
    },

  orderIndexList: (parameter) => {
    return axios({
      url: `/index/orderIndexList`,
      method: 'post',
      data: parameter
    })
  },
}